import Vue from "vue";

Vue.component("ProspectionTimeline", () => import("./Timeline.vue"));
Vue.component("ProspectionMoveForms", () => import("./MoveForms.vue"));
// Vue.component("TransferProspection", () => import("./Transfer.vue"));
// Vue.component("ProspectionShow", () => import("./Show.vue"));
